const s3BaseUrl = `${import.meta.env.VITE_AWS_S3 || ''}`.replace(/\/$/, '');

export const trainingMediaUrl = (path?: string | null) => {
    if (!path) return '';
    if (/^(https?:|blob:)/.test(path)) return path;
    return `${s3BaseUrl}/${path.replace(/^\//, '')}`;
};

export const formatSeconds = (value: number) => {
    const seconds = Math.max(0, Math.floor(value || 0));
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const rest = seconds % 60;
    if (hours) return `${hours}:${String(minutes).padStart(2, '0')}:${String(rest).padStart(2, '0')}`;
    return `${minutes}:${String(rest).padStart(2, '0')}`;
};
